import { useEffect, useState } from "react"

import { formatFileSize } from "../config/report-pdf"

/**
 * Resolves the human file-size label for a report PDF by probing the blob size.
 *
 * STUB: the size ideally comes from the response `Content-Length`; until the API
 * surfaces it we fetch the blob. Pass an empty url while the source is still
 * pending (report processing / initial load) — the label stays blank.
 */
export function useReportPdf(pdfUrl: string) {
  const [fileSizeLabel, setFileSizeLabel] = useState("")

  useEffect(() => {
    let active = true
    const source = pdfUrl
      ? fetch(pdfUrl)
          .then((r) => r.blob())
          .then((b) => (active ? formatFileSize(b.size) : null))
          .catch(() => null)
      : Promise.resolve("")
    source.then((label) => {
      if (active && label !== null) setFileSizeLabel(label)
    })
    return () => {
      active = false
    }
  }, [pdfUrl])

  return { fileSizeLabel }
}
